const checkIfDateBeforeToday = (dateYYYYMMDD) => new Date(dateYYYYMMDD).valueOf() < new Date().valueOf();

export const convertStringIntoYYYYMMDD = (dateString) => {
    const year = dateString?.substring(4,8);
    const month = dateString?.substring(2,4);
    const day = dateString?.substring(0,2);
    const formattedDate = year + '-' + month + '-' + day;

    return formattedDate;
}

export const handleExtraRepairRemakeOptions = ({
    extraRepairPeriodElements,
    updatedRepairEndDatesOfProducts, 
    updatedRemakeEndDatesOfProducts, 
    warrantyAction 
}) => {
        const isOutOfRepair = warrantyAction === 'repair' && Boolean(updatedRepairEndDatesOfProducts.find((endDate) => new Date(endDate).valueOf() < new Date().valueOf()));
        const isOutOfRemake = warrantyAction === 'remake' && Boolean(updatedRemakeEndDatesOfProducts.find((endDate) => checkIfDateBeforeToday(endDate)));
        const isOutOfWarranty = isOutOfRepair || isOutOfRemake;
        const mainProductContainer = extraRepairPeriodElements?.[0]?.parentElement?.parentElement?.parentElement;
        
        if (extraRepairPeriodElements && mainProductContainer && isOutOfWarranty) {
            //hide containers for all related product
            extraRepairPeriodElements.forEach((el) => {
                const container = el?.parentElement?.parentElement;
                if (container) container.style.display = 'none';
            });
            mainProductContainer.style.removeProperty('display');
            // show only 3 first checkboxes related extra repair so it will be visible only for the main product
            extraRepairPeriodElements[0]?.parentElement?.parentElement?.style.removeProperty('display');
            extraRepairPeriodElements[1]?.parentElement?.parentElement?.style.removeProperty('display');
            extraRepairPeriodElements[2]?.parentElement?.parentElement?.style.removeProperty('display');
            
            //to handle Extra warranty checkboxes which are on en-US market, but will be empty on other markets
            if (extraRepairPeriodElements?.length >= 3) {
                // Do not apply disabling on "Call with estimates" checkbox click
                [extraRepairPeriodElements[1], extraRepairPeriodElements[2]]?.forEach((el) => {
                    el.addEventListener('click', () => {
                        const restOfExtraRepairCheckboxes = [...extraRepairPeriodElements].filter((element) => element !== el);
    
                        if (el.checked) {
                            // "Call with estimates before repair / remake" checkbox, which is the 1st one should not be disabled. Only the checkbox with warranty period
                            restOfExtraRepairCheckboxes[0].disabled = false;
                            restOfExtraRepairCheckboxes[1].disabled = true;
                        } else {
                            restOfExtraRepairCheckboxes[0].disabled = false;
                            restOfExtraRepairCheckboxes[1].disabled = false;
                        }
                    });
                });
            }
        }
        
        else if (extraRepairPeriodElements && mainProductContainer) {
            extraRepairPeriodElements.forEach((el) => {
                const container = el?.parentElement?.parentElement;
                if (container) container.style.display = 'none';
            });
        }
}